<template>
  <div class="userAdministration">
    <div class="header clearfix">
      <div class="ser">
        <a-input
          style="width: 250px"
          v-model="searchData"
          placeholder="检索"
          allow-clear
          @change="searchEvent"
        >
          <a-icon slot="suffix" type="search" class="certain-category-icon" />
        </a-input>
      </div>
      <div class="ser">
        <a-button @click="btnAddUsers" type="primary"> 添加用户 </a-button>
      </div>
    </div>
    <div class="content">
      <a-table
        tableLayout="fixed"
        :data-source="usersList"
        :rowKey="(usersList) => usersList.id"
        :scroll="{ x: 1500 }"
        :loading="dataLoding"
        :pagination="{
          total: total,
          pageSize: pageSize,
          current: current,
          showTotal: (total) =>
            $t('public.page', { total: total, pageSize: pageSize }),
          onChange: currentChange,
        }"
      >
        <a-table-column title="姓名" :ellipsis="true" dataIndex="name">
        </a-table-column>
        <a-table-column
          title="学号或工号"
          :ellipsis="true"
          dataIndex="studentNo"
        >
        </a-table-column>
        <a-table-column :ellipsis="true" title="学院" dataIndex="college">
        </a-table-column>
        <a-table-column title="角色" dataIndex="roles"> </a-table-column>
        <a-table-column title="职称" dataIndex="title"> </a-table-column>

        <a-table-column title="省市/国家" dataIndex="location">
        </a-table-column>
        <a-table-column title="入学年份" dataIndex="entranceTime">
        </a-table-column>
        <a-table-column title="毕业年份" dataIndex="graduateTime">
        </a-table-column>
        <a-table-column title="专业名称" dataIndex="specialityName">
        </a-table-column>
        <a-table-column title="学历" dataIndex="education"> </a-table-column>
        <a-table-column :width="200" title="手机" dataIndex="phone">
        </a-table-column>
        <a-table-column :width="200" title="邮箱" dataIndex="email">
        </a-table-column>
        <!-- <a-table-column :ellipsis="true" title="邮箱" dataIndex="college2">
        </a-table-column> -->
        <a-table-column :ellipsis="true" title="查看" dataIndex="college1">
          <template slot-scope="id, usersList">
            <a @click="btnQuery(usersList.id)">查看</a>
          </template>
        </a-table-column>
        <a-table-column
          :width="150"
          fixed="right"
          title="操作"
          dataIndex="operation"
        >
          <template slot-scope="id, usersList">
            <a @click="() => btnEdit(usersList.id)">编辑</a>
            <div class="border"></div>

            <a-popconfirm
              title="确定删除?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="btnDelect(usersList.id)"
            >
              <a>删除</a>
            </a-popconfirm>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <!-- <div class="footer">普通用户、参赛者、评委、创业、企业家</div> -->
    <a-modal v-model="modalVisible" :title="modelName" @ok="handleOkAddList">
      <a-form
        :form="modelForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
        @submit="handleSubmit"
      >
        <a-form-item label="平台角色">
          <a-select
            placeholder="请选择角色"
            @change="btnSelectRoles"
            v-decorator="[
              'roles',
              {
                rules: [{ required: true, message: '请选择角色' }],
              },
            ]"
          >
            <a-select-option
              v-for="(item, index) in rolesData"
              :key="index"
              :value="item.name"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="入学时间" v-if="selectRole == '学生'">
          <a-date-picker
            valueFormat="YYYY-MM-DD"
            style="width: 100%"
            v-decorator="[
              'entranceTime',
              {
                rules: [{ required: true, message: '请选择入学时间' }],
              },
            ]"
            placeholder="请选择入学时间"
          />
        </a-form-item>
        <a-form-item label="毕业时间" v-if="selectRole == '学生'">
          <a-date-picker
            valueFormat="YYYY-MM-DD"
            style="width: 100%"
            v-decorator="[
              'graduateTime',
              {
                rules: [{ required: true, message: '请选择毕业时间' }],
              },
            ]"
            placeholder="请选择毕业时间"
          />
        </a-form-item>
        <a-form-item label="职称" v-if="selectRole == '老师'">
          <a-input
            placeholder="请输入职称"
            v-decorator="[
              'title',
              {
                rules: [{ required: true, message: '请输入职称' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="学号">
          <a-input
            placeholder="请输入学号"
            v-decorator="[
              'studentNo',
              {
                rules: [{ required: true, message: '请输入学号' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="姓名">
          <a-input
            placeholder="请输入姓名"
            v-decorator="[
              'name',
              {
                rules: [{ required: true, message: '请输入姓名' }],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="学院">
          <a-input
            placeholder="请输入学院方名字"
            v-decorator="[
              'schoolName',
              {
                rules: [{ required: true, message: '请输入学院方名字' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="院系">
          <a-input
            placeholder="请输入院系名字"
            v-decorator="[
              'college',
              {
                rules: [{ required: true, message: '请输入院系名字' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="专业">
          <a-input
            placeholder="请输入专业"
            v-decorator="[
              'specialityName',
              {
                rules: [{ required: true, message: '请输入专业' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="学历层次">
          <a-input
            placeholder="请输入学历层次"
            v-decorator="[
              'education',
              {
                rules: [{ required: true, message: '请输入学历层次' }],
              },
            ]"
          />
        </a-form-item>
        <!-- <a-form-item label="职称">
          <a-input
            placeholder="请输入职称"
            v-decorator="[
              'title',
              {
                rules: [{ required: true, message: '请输入职称' }],
              },
            ]"
          />
        </a-form-item> -->
        <!-- <a-form-item label="平台角色">
          <a-input
            placeholder="请输入平台角色"
            v-decorator="[
              'roles',
              {
                rules: [{ required: true, message: '请输入平台角色' }]
              }
            ]"
          />
        </a-form-item> -->
        <a-form-item label="手机">
          <a-input
            placeholder="请输入手机"
            v-decorator="[
              'phone',
              {
                rules: [{ required: true, message: '请输入手机' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="邮箱">
          <a-input
            placeholder="请输入邮箱"
            v-decorator="[
              'email',
              {
                rules: [{ required: true, message: '请输入邮箱' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="省市">
          <a-input
            placeholder="请输入省市"
            v-decorator="[
              'location',
              {
                rules: [{ required: true, message: '请输入省市' }],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      title="相关项目"
      :visible="Queryvisible"
      :confirm-loading="confirmLoading"
      @ok="btnCommon"
      @cancel="btnCommon"
    >
      <div style="width: 100%" class="queryBox">
        <div
          style="width: 100%; margin-top: 10px"
          class="item clearfix"
          v-for="item in queryData"
          :key="item.id"
        >
          <div style="width: 50%; float: left" class="ser">
            {{ item.itemName }}
          </div>
          <div style="width: 50%; float: left; text-align: center" class="ser">
            <a>{{ item.role }}</a>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      searchData: null,
      total: 0,
      pageSize: 10,
      current: 1,
      dataLoding: false,
      usersList: [],
      searchName: '',
      modalVisible: false,
      modelName: '',
      modelForm: this.$form.createForm(this, {
        name: 'modelForm',
      }),
      Queryvisible: false,
      confirmLoading: false,
      queryData: [],
      rolesData: [
        {
          name: '老师',
        },
        {
          name: '学生',
        },
      ],
      selectRole: '',
    }
  },
  methods: {
    btnSelectRoles(name) {
      this.selectRole = name
    },
    btnCommon() {
      this.Queryvisible = false
    },
    btnQuery(id) {
      console.log(id)
      this.Queryvisible = true
      let data = {
        studentId: id,
      }
      this.$http(this.$api.GETUSERMATCH, data).then((r) => {
        console.log(r)
        this.queryData = r.data
        // this.usersList = r.data.records;
        // this.total = r.data.total;
      })
    },
    searchEvent() {
      this.searchName = this.
      this.current = 1;
      this.getUserData()
    },
    currentChange(val) {
      console.log(val)
      this.current = val
      this.getUserData()
    },
    getUserData() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.current,
        name: this.searchName,
      }
      this.$http(this.$api.GETUSERDATA, data).then((r) => {
        console.log(r)
        this.usersList = r.data.records
        this.total = r.data.total
      })
    },
    btnAddUsers() {
      this.modelName = '添加用户'
      this.modalVisible = true
      this.selectFlag = 2
    },
    btnDelect(id) {
      let data = {
        id,
      }
      this.$http(this.$api.DELECTUSER, data).then((r) => {
        console.log(r)
        this.$notification['success']({
          message: '删除成功',
          description: '用户删除成功',
        })
        this.getUserData()
      })
    },
    btnEdit(id) {
      this.selectFlag = 1
      this.modalVisible = true
      this.modelName = '编辑用户'
      this.editId = id
      let flagData = this.usersList.find((Element) => {
        return Element.id == id
      })
      console.log(flagData)
      this.selectRole = flagData.roles
      if (this.selectRole == '学生') {
        this.$nextTick(() => {
          this.modelForm.setFieldsValue({
            // studentNo: flagData.studentNo,
            // name: flagData.name,
            // location: flagData.location,
            // schoolName: flagData.schoolName,
            // college: flagData.college,
            // specialityName: flagData.specialityName,
            entranceTime: moment(flagData.entranceTime),
            graduateTime: moment(flagData.graduateTime),
            // education: flagData.education,
            // title: flagData.title,
            // roles: flagData.roles,
            // email: flagData.email,
            // phone: flagData.phone,
          })
        })
      } else if (this.selectRole == '老师') {
        this.modelForm.setFieldsValue({
          // studentNo: flagData.studentNo,
          // name: flagData.name,
          // location: flagData.location,
          // schoolName: flagData.schoolName,
          // college: flagData.college,
          // specialityName: flagData.specialityName,
          // entranceTime: flagData.entranceTime,
          // graduateTime: flagData.graduateTime,
          // education: flagData.education,
          title: flagData.title,
          // roles: flagData.roles,
          // email: flagData.email,
          // phone: flagData.phone,
        })
      }
      this.$nextTick(() => {
        this.modelForm.setFieldsValue({
          studentNo: flagData.studentNo,
          name: flagData.name,
          location: flagData.location,
          schoolName: flagData.schoolName,
          college: flagData.college,
          specialityName: flagData.specialityName,
          // entranceTime: flagData.entranceTime,
          // graduateTime: flagData.graduateTime,
          education: flagData.education,
          // title: flagData.title,
          roles: flagData.roles,
          email: flagData.email,
          phone: flagData.phone,
        })
      })
    },
    handleOkAddList() {
      this.handleSubmit()
    },
    handleSubmit() {
      this.modelForm.validateFields((err, data) => {
        if (!err) {
          this.modalVisible = false
          console.log('Received values of form: ', data)

          if (this.selectFlag == 1) {
            data.id = parseInt(this.editId)
            //编辑基金
            this.$http(this.$api.UPDATEUSERITEM, data).then((r) => {
              console.log(r)
              this.getUserData()
              this.modelForm.resetFields()
              this.$notification.open({
                type: 'success',
                message: '编辑用户',
                description: '用户编辑成功',
              })
            })
          } else if (this.selectFlag == 2) {
            data.itemType = 0
            this.$http(this.$api.ADDUSERSITEM, data).then((r) => {
              console.log(r)
              this.getUserData()
              this.modelForm.resetFields()
              this.$notification.open({
                type: 'success',
                message: '添加用户',
                description: '用户添加成功',
              })
            })
          }
        }
      })
    },
  },
  created() {
    this.getUserData()
  },
}
</script>

<style scoped lang="less">
.userAdministration {
  width: 100%;
  height: 100%;

  .header {
    padding: 20px 20px 0 20px;
    width: 100%;
    height: 80px;
    box-sizing: border-box;

    .ser {
      width: 50%;
      float: left;
    }

    .ser:last-child {
      /deep/ .ant-btn {
        float: right;
      }
    }
  }

  .content {
    padding: 0 20px;
    box-sizing: border-box;
  }

  .footer {
    width: 100%;
    height: 50px;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: right;
    font-size: 16px;
  }

  /deep/ .ant-table-tbody {
    .border {
      position: relative;
      top: -0.06em;
      display: inline-block;
      width: 1px;
      height: 0.9em;
      margin: 0 8px;
      vertical-align: middle;
      background-color: #e8e8e8;
    }
    .queryBox {
      width: 100%;
      .item {
        width: 100%;
        .ser {
          float: left;
          width: 50%;
        }
        .ser {
          color: #199ed8;
        }
      }
    }
  }
}
</style>
